import React, { FC, useEffect } from 'react';

import { Loader } from 'ui';

import { UserContext } from 'context/UserContext';

import { useAppDispatch, useAppSelector } from 'hooks';

import { getProfile } from './slices/profileSlice';
import { getStand } from 'features/Stand/slices/standSlice';

export const Profile: FC<Props> = ({ children }) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getProfile());
    dispatch(getStand());
  }, [dispatch]);

  const profile = useAppSelector(state => state.profile.user);
  const loading = useAppSelector(state => state.profile.loading);

  if (loading) {
    return <Loader type='start' />;
  }

  return (
    <>
      <UserContext.Provider value={profile}>{children}</UserContext.Provider>
    </>
  );
};

type Props = {
  children: React.ReactNode;
};
